var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3671.6052,
    y1: 4079.833,
    x2: 1113.2445,
    y2: 902.5093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M2932.963,2852.856c-53.617,63.152-111.044,98.795-153.699,129.397 c-501.392,359.721-1094.671,254.864-1220.76,229.257c-186.193-37.813-546.101-110.906-806.308-416.875 C358.525,2331.729,389.54,1475.671,694.898,994.253c55.855-88.06,336.663-504.995,980.851-528.429 c365.759-13.306,813.573-37.941,1119.927,218.699C3438.741,1223.234,3327.603,2388.038,2932.963,2852.856z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M2914.144,517.141c-5.555-3.513-13.1-8.864-16.351-4.373 c-52.565,72.593-172.228,281.123-75.365,573.773c121.529,367.175,66.475,524.468-19.105,632.61 c22.984-3.597,66.054-12.669,110.6-39.545C3259.054,1471.378,3033.099,592.38,2914.144,517.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2888.602,646.719c0.217,43.998,1.326,87.922,4.088,131.656 c2.525,43.753,6.416,87.34,11.706,130.673c5.462,43.3,11.764,86.45,19.957,129.175c7.993,42.77,17.885,85.057,27.971,127.473 c9.834,42.459,19.992,85.165,25.627,129.25c5.665,43.986,5.984,89.623-2.288,134.414c-2.074,11.166-4.363,22.349-7.3,33.326 c-2.732,11.023-5.96,21.957-9.385,32.841c-6.961,21.746-15.394,43.156-25.388,63.945c-20.098,41.54-46.523,80.406-77.185,115.246 c-3.227,3.667-8.759,4.249-12.357,1.301c-3.533-2.895-3.885-8.118-0.841-11.778l0.021-0.026 c7.222-8.667,14.338-17.398,21.047-26.387c3.426-4.447,6.65-9.023,9.958-13.542c3.134-4.626,6.448-9.145,9.438-13.853 c12.27-18.647,23.226-38.041,32.695-58.05c19.116-39.896,32.352-82.461,40.33-125.241c3.744-21.427,5.873-43.001,6.295-64.57 c0.406-21.571-0.891-43.115-3.458-64.537c-5.134-42.869-14.824-85.238-24.34-127.78c-9.46-42.566-18.662-85.42-26.016-128.672 c-3.737-21.61-7.07-43.304-9.999-65.067c-1.529-10.869-2.84-21.777-4.171-32.679c-1.223-10.921-2.383-21.85-3.45-32.79 c-4.187-43.777-6.991-87.729-8.359-131.781c-1.149-44.07-1.094-88.218,0.711-132.381c0.052-1.263,1.144-2.3,2.439-2.318 C2887.606,644.551,2888.594,645.508,2888.602,646.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M2796.109,1863.363c-6.33,15.906-28.642,16.558-35.981,1.092 c-80.831-170.322-389.705-852.922-401.787-1362.643c-0.863-36.397,39.076-59.196,69.778-39.63 C2622.167,585.842,3136.148,1008.863,2796.109,1863.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2492.751,700.133c13.599,20.788,25.712,42.454,37.426,64.323 c11.624,21.917,22.742,44.109,33.23,66.599c21.094,44.926,40.073,90.833,57.575,137.286 c17.469,46.471,33.301,93.557,47.774,141.062c14.478,47.509,27.199,95.538,38.951,143.8l8.527,36.269l7.888,36.415l3.915,18.216 l3.577,18.284l7.128,36.578c8.688,48.914,16.962,97.937,23.298,147.232c13.223,98.516,21.854,197.664,26.204,297.009 c0.244,5.573-4.075,10.288-9.649,10.533c-5.573,0.244-10.289-4.076-10.533-9.649c-0.001-0.036-0.005-0.134-0.006-0.171 c-2.733-98.831-9.728-197.565-21.304-295.793c-5.513-49.153-12.961-98.06-20.824-146.896l-6.51-36.524l-3.267-18.263 l-3.607-18.196l-7.269-36.387l-7.911-36.255c-10.928-48.251-22.83-96.307-36.495-143.88 c-13.66-47.569-28.685-94.759-45.357-141.376c-16.704-46.6-34.899-92.697-55.223-137.862 c-10.104-22.609-20.842-44.932-32.091-66.997c-11.334-22.007-23.095-43.857-36.305-64.782l-0.011-0.016 c-0.153-0.242-0.08-0.562,0.161-0.714C2492.282,699.827,2492.598,699.897,2492.751,700.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M888.14,836.587c-4.233-0.012-7.86-3.22-8.298-7.523c-0.961-9.411-1.526-19.003-1.682-28.51 c-0.076-4.625,3.611-8.436,8.235-8.512c0.056,0,0.11,0,0.164,0c4.55,0.012,8.273,3.667,8.347,8.236 c0.147,9.032,0.685,18.144,1.596,27.083c0.47,4.6-2.879,8.713-7.482,9.182C888.726,836.575,888.432,836.587,888.14,836.587z  M888.878,763.634c-0.327-0.001-0.659-0.021-0.993-0.061c-4.591-0.555-7.864-4.729-7.309-9.32 c1.143-9.431,2.699-18.907,4.628-28.162c0.943-4.528,5.359-7.424,9.907-6.493c4.528,0.944,7.432,5.382,6.489,9.906 c-1.833,8.798-3.311,17.799-4.395,26.763C896.69,760.525,893.063,763.646,888.878,763.634z M905.66,692.659 c-0.932-0.003-1.88-0.162-2.808-0.495c-4.351-1.566-6.614-6.361-5.05-10.714c3.204-8.922,6.838-17.816,10.8-26.435 c1.935-4.202,6.907-6.037,11.107-4.112c4.201,1.932,6.043,6.906,4.111,11.107c-3.763,8.184-7.212,16.628-10.256,25.102 C912.334,690.538,909.101,692.668,905.66,692.659z M937.898,627.205c-1.541-0.004-3.098-0.434-4.491-1.327 c-3.893-2.497-5.023-7.678-2.527-11.57c5.125-7.984,10.655-15.843,16.437-23.358c2.822-3.659,8.077-4.345,11.745-1.529 c3.664,2.82,4.349,8.078,1.529,11.745c-5.492,7.136-10.746,14.6-15.613,22.189 C943.372,625.852,940.664,627.212,937.898,627.205z M983.922,570.584c-2.161-0.006-4.318-0.843-5.95-2.506 c-3.243-3.299-3.195-8.602,0.104-11.842c6.75-6.632,13.881-13.07,21.192-19.128c3.559-2.954,8.839-2.462,11.791,1.102 c2.951,3.561,2.457,8.839-1.104,11.793c-6.95,5.758-13.727,11.877-20.142,18.179 C988.176,569.791,986.047,570.59,983.922,570.584z M1041.32,525.557c-2.799-0.007-5.53-1.415-7.109-3.971 c-2.431-3.935-1.213-9.094,2.72-11.527c8.063-4.983,16.441-9.684,24.901-13.966c4.129-2.089,9.165-0.436,11.254,3.691 c2.089,4.124,0.437,9.164-3.689,11.253c-8.039,4.07-15.998,8.534-23.659,13.269 C1044.359,525.16,1042.83,525.562,1041.32,525.557z M1348.239,506.45c-1.16-0.003-2.335-0.248-3.457-0.762 c-8.181-3.745-16.636-7.183-25.129-10.215c-4.355-1.556-6.625-6.348-5.069-10.701c1.554-4.356,6.346-6.627,10.702-5.071 c8.945,3.194,17.851,6.813,26.466,10.756c4.206,1.925,6.054,6.896,4.129,11.1 C1354.471,504.642,1351.422,506.458,1348.239,506.45z M1107.228,494.391c-3.474-0.009-6.715-2.197-7.901-5.668 c-1.496-4.378,0.839-9.137,5.215-10.634c8.97-3.067,18.182-5.78,27.382-8.065c4.492-1.094,9.032,1.618,10.147,6.109 c1.115,4.488-1.621,9.031-6.11,10.147c-8.737,2.168-17.484,4.745-26.002,7.656 C1109.053,494.246,1108.132,494.394,1107.228,494.391z M1278.906,483.763c-0.553-0.001-1.114-0.055-1.676-0.171 c-8.817-1.82-17.83-3.28-26.787-4.348c-4.593-0.549-7.872-4.716-7.325-9.307c0.549-4.591,4.712-7.894,9.307-7.325 c9.424,1.125,18.909,2.662,28.187,4.574c4.53,0.935,7.446,5.365,6.511,9.894 C1286.304,481.045,1282.805,483.773,1278.906,483.763z M1178.444,478.728c-4.226-0.011-7.85-3.211-8.297-7.507 c-0.478-4.601,2.863-8.717,7.464-9.198c9.419-0.979,19.007-1.564,28.497-1.735c0.059-0.003,0.119-0.003,0.178-0.003 c4.543,0.012,8.263,3.657,8.347,8.22c0.084,4.626-3.595,8.443-8.221,8.525c-9.014,0.165-18.121,0.723-27.07,1.654 C1179.041,478.714,1178.741,478.729,1178.444,478.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1399.276,535.659c-1.649-0.005-3.314-0.493-4.769-1.511c-3.538-2.476-7.187-4.916-10.844-7.262 c-3.894-2.493-5.03-7.675-2.535-11.567c2.493-3.896,7.676-5.036,11.569-2.533c3.849,2.464,7.685,5.032,11.409,7.636 c3.789,2.65,4.714,7.873,2.064,11.661C1404.536,534.42,1401.926,535.666,1399.276,535.659z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1534.736,752.075c-4.042-0.011-7.591-2.951-8.241-7.072c-0.67-4.264-1.442-8.588-2.294-12.846 c-0.907-4.536,2.034-8.948,6.569-9.855c4.554-0.91,8.948,2.036,9.855,6.569c0.896,4.484,1.709,9.036,2.417,13.526 c0.719,4.569-2.402,8.855-6.97,9.575C1535.623,752.045,1535.176,752.076,1534.736,752.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1212.033,1129.205c-3.853-0.01-7.721-0.087-11.602-0.228c-4.622-0.17-8.233-4.052-8.065-8.674 c0.168-4.622,4.074-8.249,8.673-8.066c8.957,0.325,17.907,0.287,26.703-0.121c4.624-0.207,8.539,3.356,8.754,7.976 c0.215,4.623-3.358,8.542-7.978,8.755C1223.077,1129.1,1217.53,1129.22,1212.033,1129.205z M1156.46,1124.354 c-0.468-0.001-0.943-0.042-1.421-0.125c-9.206-1.598-18.446-3.606-27.463-5.966c-4.473-1.17-7.152-5.747-5.982-10.219 c1.172-4.475,5.757-7.165,10.222-5.981c8.565,2.241,17.343,4.146,26.091,5.668c4.556,0.791,7.608,5.127,6.817,9.681 C1164.014,1121.492,1160.466,1124.365,1156.46,1124.354z M1272.291,1123.758c-3.948-0.011-7.455-2.824-8.202-6.846 c-0.843-4.549,2.16-8.918,6.708-9.763c8.699-1.612,17.447-3.62,26.004-5.972c4.462-1.218,9.069,1.399,10.294,5.857 c1.224,4.462-1.399,9.07-5.859,10.295c-9.011,2.475-18.225,4.589-27.386,6.288 C1273.327,1123.715,1272.805,1123.759,1272.291,1123.758z M1087.494,1104.347c-1.063-0.003-2.142-0.212-3.184-0.643 c-8.622-3.579-17.194-7.57-25.479-11.861c-4.106-2.128-5.71-7.18-3.583-11.286c2.128-4.109,7.178-5.715,11.287-3.584 c7.866,4.074,16.006,7.865,24.194,11.263c4.272,1.771,6.297,6.674,4.524,10.944 C1093.914,1102.408,1090.786,1104.356,1087.494,1104.347z M1340.955,1102.942c-3.239-0.009-6.318-1.908-7.677-5.075 c-1.824-4.251,0.144-9.175,4.395-10.999c8.127-3.484,16.219-7.369,24.053-11.541c4.082-2.174,9.154-0.629,11.328,3.456 c2.173,4.082,0.626,9.151-3.455,11.325c-8.247,4.394-16.767,8.483-25.324,12.153 C1343.193,1102.726,1342.063,1102.945,1340.955,1102.942z M1403.389,1067.563c-2.589-0.007-5.139-1.211-6.772-3.469 c-2.708-3.75-1.865-8.985,1.885-11.693c7.189-5.195,14.244-10.753,20.967-16.519c3.507-3.016,8.792-2.613,11.808,0.902 c3.011,3.512,2.606,8.797-0.904,11.81c-7.076,6.068-14.499,11.917-22.065,17.382 C1406.821,1067.053,1405.097,1067.568,1403.389,1067.563z M1456.626,1019.415c-1.969-0.005-3.943-0.701-5.532-2.112 c-3.459-3.068-3.775-8.362-0.706-11.821c5.893-6.641,11.569-13.6,16.871-20.69c2.769-3.702,8.014-4.463,11.722-1.689 c3.702,2.771,4.46,8.017,1.689,11.722c-5.581,7.459-11.555,14.787-17.754,21.774 C1461.256,1018.469,1458.945,1019.421,1456.626,1019.415z M1498.092,960.806c-1.364-0.004-2.745-0.341-4.024-1.048 c-4.047-2.238-5.512-7.333-3.273-11.379c4.296-7.764,8.307-15.797,11.924-23.88c1.889-4.221,6.849-6.112,11.063-4.226 c4.223,1.889,6.113,6.844,4.224,11.065c-3.809,8.514-8.034,16.975-12.556,25.148 C1503.917,959.255,1501.047,960.814,1498.092,960.806z M1525.69,894.498c-0.767-0.002-1.547-0.112-2.32-0.337 c-4.44-1.291-6.994-5.94-5.701-10.378c2.471-8.498,4.613-17.214,6.364-25.91c0.913-4.535,5.343-7.464,9.862-6.555 c4.534,0.912,7.47,5.329,6.557,9.864c-1.844,9.154-4.098,18.331-6.701,27.277 C1532.684,892.126,1529.328,894.508,1525.69,894.498z M1538.039,823.795c-0.172-0.001-0.345-0.008-0.518-0.018 c-4.615-0.294-8.119-4.274-7.824-8.889c0.415-6.515,0.634-13.119,0.652-19.636c0.006-2.359-0.015-4.714-0.059-7.059 c-0.087-4.625,3.59-8.446,8.214-8.532c4.68-0.18,8.443,3.589,8.532,8.211c0.047,2.47,0.068,4.943,0.062,7.426 c-0.019,6.853-0.25,13.804-0.687,20.656C1546.128,820.395,1542.43,823.807,1538.039,823.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1024.465,1069.524c-1.665-0.005-3.343-0.503-4.805-1.534 c-3.702-2.617-7.419-5.362-11.047-8.159c-3.664-2.823-4.346-8.082-1.522-11.744c2.825-3.663,8.078-4.349,11.745-1.522 c3.447,2.656,6.978,5.263,10.492,7.748c3.776,2.667,4.675,7.893,2.005,11.671 C1029.696,1068.299,1027.099,1069.531,1024.465,1069.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1036.028,972.423c1.052,1.296,2.811,1.783,4.38,1.211l44.754-16.32 c17.589,13.622,37.476,24.537,59.106,32.037l10.779,46.37c0.378,1.627,1.747,2.834,3.407,3.007l56.833,5.913 c1.661,0.172,3.249-0.728,3.953-2.241l20.093-43.159c22.712-2.888,44.42-9.475,64.435-19.186l40.437,25.183 c1.417,0.883,3.238,0.769,4.535-0.283l44.368-36.006c1.297-1.053,1.783-2.812,1.211-4.38L1378,919.815 c13.622-17.588,24.537-37.476,32.037-59.107l46.371-10.779c1.626-0.378,2.833-1.746,3.006-3.407l5.913-56.834 c0.173-1.661-0.727-3.248-2.241-3.953l-43.159-20.093c-2.887-22.712-9.474-44.42-19.185-64.435l25.184-40.438 c0.882-1.417,0.768-3.238-0.284-4.535l-36.007-44.368c-1.052-1.297-2.811-1.783-4.38-1.211l-44.754,16.321 c-17.588-13.623-37.476-24.538-59.107-32.037l-10.779-46.371c-0.378-1.626-1.746-2.834-3.407-3.007l-56.834-5.912 c-1.661-0.173-3.248,0.727-3.953,2.241l-20.093,43.159c-22.712,2.886-44.42,9.475-64.436,19.185l-40.436-25.183 c-1.417-0.883-3.24-0.769-4.536,0.283l-44.368,36.007c-1.297,1.052-1.783,2.811-1.211,4.38l16.32,44.754 c-13.622,17.588-24.537,37.476-32.037,59.107l-46.371,10.779c-1.626,0.378-2.834,1.746-3.006,3.408l-5.913,56.833 c-0.173,1.661,0.727,3.248,2.241,3.954l43.158,20.093c2.887,22.711,9.475,44.419,19.185,64.435l-25.183,40.437 c-0.883,1.418-0.769,3.238,0.283,4.536L1036.028,972.423z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175324291076630550820000000735021853195307140_",
    gradientUnits: "userSpaceOnUse",
    x1: 1155.3916,
    y1: 792.1404,
    x2: 1270.2725,
    y2: 792.1404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175324291076630550820000000735021853195307140_)"
    },
    d: "M1212.639,849.585 c-27.998-0.076-52.527-20.702-56.651-49.218c-4.532-31.347,17.28-60.532,48.624-65.066c15.186-2.2,30.316,1.652,42.602,10.835 c12.29,9.183,20.268,22.603,22.462,37.787c4.533,31.347-17.28,60.532-48.624,65.066 C1218.227,849.397,1215.414,849.592,1212.639,849.585z M1213.045,748.1c-2.162-0.006-4.336,0.145-6.516,0.46 c-24.031,3.475-40.755,25.857-37.281,49.886c3.476,24.033,25.85,40.767,49.888,37.283 c24.031-3.474,40.755-25.856,37.281-49.886c-1.684-11.644-7.8-21.932-17.223-28.974 C1231.535,751.147,1222.434,748.125,1213.045,748.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096023269442969652180000001485635136637650353_",
    gradientUnits: "userSpaceOnUse",
    x1: 1072.4792,
    y1: 791.3066,
    x2: 1354.9531,
    y2: 791.3066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096023269442969652180000001485635136637650353_)"
    },
    d: "M1213.589,932.545 c-4.808-0.013-9.644-0.268-14.492-0.772l0,0c-1.526-0.158-3.05-0.342-4.57-0.549c-7.497-1.025-14.9-2.644-22.095-4.833 c-0.098-0.03-0.196-0.06-0.294-0.089c-0.278-0.086-0.556-0.172-0.833-0.261c-0.541-0.168-1.08-0.343-1.618-0.518 c-1.415-0.462-2.313-1.776-2.311-3.189c0.001-0.343,0.056-0.693,0.168-1.037c0.574-1.758,2.467-2.712,4.224-2.141 c9.048,2.959,18.476,4.96,28.021,5.951c47.414,4.94,91.721-15.509,119.373-50.331c15.383-19.367,25.611-43.182,28.353-69.554 c0.482-4.624,0.727-9.239,0.737-13.826c0.08-30.867-10.371-60.575-30.084-84.864c-22.643-27.902-54.797-45.317-90.537-49.035 c-73.813-7.671-140.052,46.108-147.726,119.885c-0.474,4.549-0.715,9.105-0.725,13.649 c-0.05,19.689,4.209,39.171,12.539,57.031c0.215,0.462,0.316,0.946,0.314,1.424c-0.003,1.256-0.718,2.461-1.934,3.027 c-1.68,0.777-3.671,0.062-4.452-1.621c-8.746-18.751-13.219-39.205-13.166-59.876c0.011-4.769,0.265-9.551,0.76-14.326 c8.057-77.46,77.651-133.912,155.083-125.859c37.521,3.903,71.275,22.185,95.046,51.478 c20.696,25.499,31.667,56.687,31.584,89.091c-0.013,4.815-0.27,9.659-0.774,14.512c-3.905,37.523-22.185,71.278-51.476,95.049 C1277.197,921.663,1246,932.632,1213.589,932.545z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M601.769,1056.5c-2.238-0.006-4.295-1.471-4.95-3.731c-1.226-4.216-2.341-8.528-3.312-12.813 c-0.631-2.785,1.114-5.553,3.901-6.187c2.788-0.644,5.556,1.116,6.187,3.901c0.926,4.084,1.988,8.193,3.157,12.217 c0.798,2.74-0.781,5.609-3.523,6.41C602.741,1056.437,602.251,1056.501,601.769,1056.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M594.22,1017.435c-2.621-0.007-4.864-1.998-5.127-4.661c-0.748-7.523-1.116-15.172-1.096-22.728 c0.004-1.591,0.027-3.187,0.064-4.788c0.071-2.858,2.592-5.008,5.294-5.052c2.856,0.068,5.115,2.439,5.049,5.292 c-0.037,1.53-0.059,3.056-0.063,4.576c-0.019,7.208,0.332,14.503,1.043,21.677c0.283,2.845-1.792,5.375-4.634,5.66 C594.571,1017.425,594.394,1017.435,594.22,1017.435z M595.501,963.745c-0.245-0.001-0.495-0.016-0.742-0.052 c-2.828-0.417-4.783-3.044-4.369-5.871c1.328-9.069,3.232-18.135,5.657-26.943c0.757-2.756,3.618-4.364,6.359-3.614 c2.756,0.76,4.372,3.603,3.614,6.359c-2.314,8.404-4.128,17.052-5.396,25.7C600.247,961.9,598.032,963.752,595.501,963.745z  M609.764,911.971c-0.656-0.002-1.323-0.13-1.966-0.394c-2.638-1.093-3.888-4.122-2.795-6.761 c3.508-8.451,7.581-16.779,12.114-24.742c1.414-2.487,4.563-3.352,7.054-1.936c2.481,1.411,3.349,4.57,1.938,7.051 c-4.321,7.595-8.207,15.53-11.55,23.593C613.73,910.774,611.797,911.976,609.764,911.971z M636.32,865.285 c-1.071-0.003-2.148-0.339-3.073-1.024c-2.289-1.708-2.763-4.952-1.054-7.241c5.483-7.35,11.467-14.42,17.794-21.02 c1.978-2.06,5.254-2.122,7.312-0.152c2.063,1.975,2.132,5.248,0.154,7.314c-6.03,6.288-11.741,13.036-16.968,20.042 C639.467,864.571,637.904,865.289,636.32,865.285z M673.472,826.502c-1.495-0.004-2.979-0.655-3.998-1.905 c-1.804-2.212-1.472-5.469,0.74-7.276c7.098-5.785,14.618-11.189,22.354-16.057c2.419-1.529,5.612-0.798,7.133,1.621 c1.521,2.419,0.795,5.614-1.621,7.132c-7.382,4.648-14.556,9.8-21.326,15.323C675.789,826.125,674.626,826.505,673.472,826.502 z M718.905,797.915c-1.937-0.005-3.793-1.107-4.672-2.978c-1.213-2.584-0.098-5.662,2.486-6.878 c8.289-3.887,16.901-7.294,25.591-10.119c2.727-0.877,5.635,0.606,6.519,3.321c0.884,2.715-0.604,5.635-3.318,6.517 c-8.289,2.695-16.495,5.941-24.397,9.647C720.399,797.763,719.646,797.917,718.905,797.915z M769.936,781.308 c-2.424-0.007-4.584-1.724-5.06-4.191c-0.541-2.805,1.295-5.517,4.1-6.06c8.96-1.729,18.146-2.916,27.306-3.533 c2.859-0.144,5.319,1.97,5.507,4.818c0.192,2.849-1.964,5.314-4.813,5.508c-8.738,0.583-17.499,1.716-26.042,3.364 C770.598,781.28,770.264,781.309,769.936,781.308z M850.241,780.87c-0.298-0.001-0.604-0.027-0.909-0.083 c-7.421-1.339-15.046-2.294-22.664-2.839c-1.154-0.089-2.287-0.163-3.419-0.222c-2.854-0.159-5.039-2.595-4.882-5.448 c0.152-2.859,2.613-5.125,5.446-4.885c1.207,0.069,2.411,0.143,3.621,0.237c7.959,0.572,15.952,1.574,23.734,2.979 c2.812,0.508,4.679,3.195,4.171,6.007C854.888,779.119,852.704,780.876,850.241,780.87z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M813.831,1213.823c-2.823-0.008-5.126-2.287-5.156-5.12c-0.03-2.854,2.262-5.197,5.118-5.224 c8.6-0.088,17.266-0.701,25.76-1.824c2.817-0.346,5.433,1.616,5.807,4.45c0.374,2.834-1.621,5.431-4.45,5.807 c-8.908,1.173-17.994,1.82-27.008,1.912C813.879,1213.823,813.854,1213.823,813.831,1213.823z M787.402,1212.504 c-0.187-0.001-0.371-0.011-0.561-0.032c-8.951-0.984-17.932-2.523-26.695-4.573c-2.781-0.654-4.509-3.432-3.857-6.213 c0.649-2.787,3.447-4.501,6.213-3.862c8.362,1.957,16.932,3.425,25.473,4.367c2.838,0.311,4.887,2.867,4.574,5.705 C792.257,1210.552,790.009,1212.511,787.402,1212.504z M866.186,1206.893c-2.293-0.006-4.385-1.547-4.99-3.873 c-0.718-2.76,0.939-5.584,3.704-6.304c8.328-2.17,16.591-4.859,24.565-8.005c2.667-1.038,5.661,0.258,6.707,2.918 c1.048,2.655-0.257,5.661-2.915,6.71c-8.359,3.296-17.023,6.116-25.753,8.386 C867.063,1206.84,866.621,1206.895,866.186,1206.893z M735.957,1200.434c-0.588-0.002-1.186-0.104-1.772-0.318 c-8.457-3.109-16.807-6.774-24.814-10.892c-2.542-1.305-3.541-4.424-2.236-6.966c1.305-2.532,4.424-3.534,6.964-2.234 c7.637,3.925,15.596,7.416,23.659,10.383c2.68,0.987,4.055,3.96,3.068,6.64C740.054,1199.142,738.068,1200.44,735.957,1200.434 z M915.31,1187.514c-1.831-0.005-3.604-0.984-4.536-2.704c-1.365-2.514-0.432-5.653,2.077-7.015 c7.545-4.091,14.917-8.688,21.913-13.669c2.331-1.661,5.559-1.111,7.215,1.217c1.656,2.328,1.112,5.559-1.216,7.215 c-7.338,5.218-15.067,10.041-22.976,14.333C916.997,1187.317,916.146,1187.516,915.31,1187.514z M958.352,1156.915 c-1.402-0.004-2.794-0.573-3.812-1.688c-1.924-2.111-1.773-5.384,0.338-7.307c6.359-5.797,12.423-12.029,18.019-18.519 c1.867-2.167,5.136-2.406,7.295-0.541c2.164,1.865,2.405,5.128,0.541,7.29c-5.868,6.808-12.222,13.342-18.886,19.416 C960.853,1156.472,959.599,1156.919,958.352,1156.915z M992.827,1116.882c-0.985-0.003-1.979-0.283-2.859-0.876 c-2.375-1.588-3.01-4.802-1.421-7.176c4.79-7.145,9.18-14.649,13.047-22.301c1.29-2.542,4.401-3.569,6.949-2.279 c2.55,1.29,3.571,4.399,2.282,6.951c-4.058,8.021-8.66,15.893-13.681,23.39 C996.143,1116.083,994.499,1116.887,992.827,1116.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M688.755,1176.157c-0.998-0.003-2.005-0.293-2.892-0.897c-3.66-2.49-7.262-5.101-10.71-7.757 c-2.261-1.744-2.684-4.993-0.94-7.256c1.746-2.253,4.99-2.679,7.256-0.94c3.286,2.534,6.724,5.024,10.216,7.402 c2.362,1.607,2.972,4.826,1.365,7.186C692.045,1175.368,690.414,1176.162,688.755,1176.157z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M693.236,1109.351c0.704,0.867,1.881,1.193,2.93,0.81l29.948-10.921 c11.769,9.115,25.077,16.42,39.551,21.438l7.213,31.028c0.253,1.089,1.168,1.896,2.28,2.012l38.03,3.957 c1.112,0.115,2.174-0.487,2.646-1.5l13.445-28.88c15.198-1.932,29.724-6.34,43.117-12.838l27.058,16.852 c0.949,0.59,2.167,0.514,3.035-0.19l29.689-24.094c0.868-0.705,1.193-1.881,0.81-2.931l-10.921-29.947 c9.115-11.769,16.419-25.078,21.438-39.552l31.029-7.213c1.088-0.253,1.896-1.169,2.012-2.28l3.956-38.031 c0.116-1.112-0.486-2.174-1.499-2.645l-28.88-13.445c-1.932-15.198-6.34-29.724-12.838-43.117l16.852-27.059 c0.59-0.948,0.514-2.167-0.189-3.034l-24.094-29.689c-0.704-0.868-1.881-1.193-2.93-0.81l-29.948,10.922 c-11.769-9.116-25.077-16.419-39.551-21.438l-7.213-31.029c-0.253-1.088-1.168-1.896-2.28-2.012l-38.031-3.956 c-1.111-0.116-2.173,0.487-2.645,1.5l-13.445,28.88c-15.198,1.932-29.724,6.34-43.118,12.838l-27.058-16.851 c-0.949-0.591-2.168-0.515-3.035,0.189l-29.689,24.094c-0.867,0.704-1.193,1.881-0.81,2.931l10.92,29.947 c-9.115,11.769-16.419,25.077-21.438,39.552l-31.029,7.213c-1.087,0.253-1.896,1.168-2.011,2.28l-3.957,38.03 c-0.115,1.112,0.487,2.174,1.5,2.646l28.88,13.445c1.932,15.197,6.34,29.723,12.837,43.117l-16.851,27.059 c-0.591,0.948-0.514,2.167,0.189,3.035L693.236,1109.351z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180342794357323070520000013964440356730859649_",
    gradientUnits: "userSpaceOnUse",
    x1: 772.4182,
    y1: 988.7218,
    x2: 850.676,
    y2: 988.7218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180342794357323070520000013964440356730859649_)"
    },
    d: "M811.356,1027.847 c-8.344-0.023-16.429-2.706-23.234-7.791c-8.37-6.256-13.804-15.398-15.298-25.741c-3.089-21.344,11.767-41.225,33.118-44.319 c21.385-3.054,41.236,11.774,44.322,33.123c1.497,10.344-1.124,20.651-7.38,29.019c-6.255,8.373-15.397,13.808-25.743,15.301 C815.208,1027.716,813.274,1027.852,811.356,1027.847z M811.639,959.936c-1.392-0.004-2.799,0.094-4.216,0.297 c-15.705,2.276-26.632,16.899-24.361,32.604c1.101,7.605,5.096,14.334,11.253,18.932c6.16,4.603,13.739,6.523,21.349,5.432l0,0 c7.607-1.101,14.334-5.098,18.934-11.253c4.603-6.16,6.53-13.741,5.43-21.352C837.962,970.311,825.668,959.974,811.639,959.936 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088099762552695217590000001905730089925130886_",
    gradientUnits: "userSpaceOnUse",
    x1: 714.6937,
    y1: 988.1488,
    x2: 909.5758,
    y2: 988.1488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088099762552695217590000001905730089925130886_)"
    },
    d: "M811.943,1085.592 c-3.273-0.009-6.571-0.185-9.894-0.527c-6.597-0.684-13.132-2.041-19.438-4.038c-0.283-0.092-0.565-0.184-0.848-0.275 c-2.185-0.713-3.571-2.742-3.568-4.924c0.001-0.53,0.086-1.07,0.259-1.6c0.887-2.715,3.81-4.182,6.522-3.306 c5.87,1.92,11.972,3.214,18.138,3.853h0.003c0.338,0.036,0.679,0.067,1.015,0.099c14.606,1.378,29.003-0.937,42.143-6.558 c7.133-3.052,13.897-7.085,20.121-12.043c0.051-0.04,0.101-0.08,0.152-0.121c0.155-0.126,0.309-0.247,0.461-0.373 c18.061-14.66,29.336-35.475,31.743-58.612c0.314-2.994,0.471-5.979,0.479-8.949c0.052-19.982-6.716-39.214-19.477-54.943 c-14.66-18.062-35.475-29.332-58.61-31.738c-23.122-2.396-45.827,4.341-63.892,18.996 c-18.061,14.66-29.336,35.475-31.743,58.612c-0.308,2.944-0.463,5.894-0.471,8.833c-0.032,12.749,2.724,25.359,8.118,36.92 c0.332,0.713,0.489,1.461,0.484,2.198c-0.005,1.94-1.109,3.801-2.985,4.674c-2.592,1.2-5.665,0.091-6.875-2.504 c-6.034-12.937-9.12-27.048-9.086-41.307c0.009-3.293,0.182-6.591,0.524-9.884c2.694-25.889,15.306-49.176,35.517-65.577 c20.208-16.397,45.58-23.965,71.477-21.253c25.887,2.691,49.173,15.301,65.573,35.514 c14.28,17.591,21.848,39.109,21.791,61.465c-0.009,3.318-0.185,6.662-0.532,10.01 C903.826,1048.351,861.286,1085.726,811.943,1085.592z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M2170.603,1144.21c-0.423-20.747-18.745-37.819-41.205-37.819h-848.915 c-22.76,0-45.113,17.962-45.113,38.991v1879.552c0,10.116,6.309,19.818,14.06,26.961c7.754,7.143,19.24,11.142,30.19,11.114 l887.587-2.239c11.044-0.027,21.857-4.15,29.583-11.443c7.725-7.294,12.081-17.374,11.873-27.577L2170.603,1144.21z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1545.422,1327.874 1303.584,1327.575 1301.666,1213.047 1543.738,1213.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1816.494,1327.817 1574.9,1327.517 1573.244,1213.047 1815.073,1213.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2087.293,1327.76 1845.941,1327.459 1844.55,1213.047 2086.135,1213.047  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1548.443,1533.445 1307.028,1533.588 1305.116,1419.809 1546.765,1419.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1819.043,1533.286 1577.87,1533.428 1576.221,1419.706 1817.628,1419.614  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2089.372,1533.126 1848.441,1533.268 1847.053,1419.603 2088.218,1419.511  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1551.455,1737.604 1310.459,1737.838 1308.554,1624.454 1549.783,1624.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1821.585,1737.342 1580.83,1737.576 1579.187,1624.248 1820.174,1624.065  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2091.444,1737.08 1850.931,1737.314 1849.548,1624.043 2090.293,1623.859  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1554.457,1941.057 1313.879,1941.381 1311.981,1828.388 1552.79,1828.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1824.118,1940.693 1583.781,1941.016 1582.143,1828.081 1822.712,1827.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2093.509,1940.329 1853.412,1940.653 1852.034,1827.774 2092.362,1827.501  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1557.448,2143.805 1317.287,2144.219 1315.395,2031.618 1555.787,2031.253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1826.641,2143.341 1586.721,2143.754 1585.089,2031.209 1825.24,2030.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2095.566,2142.878 1855.885,2143.291 1854.512,2030.801 2094.424,2030.438  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1560.429,2345.855 1320.684,2346.358 1318.798,2234.145 1558.774,2233.691  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1829.157,2345.291 1589.651,2345.793 1588.024,2233.636 1827.76,2233.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2097.617,2344.727 1858.35,2345.229 1856.981,2233.128 2096.478,2232.675  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1563.399,2547.208 1324.069,2547.8 1322.19,2435.973 1561.75,2435.431  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1831.663,2546.545 1592.571,2547.136 1590.95,2435.365 1830.271,2434.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2099.66,2545.883 1860.806,2546.473 1859.442,2434.757 2098.525,2434.215  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1566.359,2747.869 1327.442,2748.549 1325.569,2637.107 1564.715,2636.476  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1834.16,2747.108 1595.481,2747.787 1593.865,2636.399 1832.774,2635.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2101.696,2746.347 1863.253,2747.025 1861.895,2635.692 2100.565,2635.063  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1569.309,2947.842 1330.803,2948.609 1328.938,2837.55 1567.671,2836.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1836.65,2946.982 1598.38,2947.749 1596.77,2836.743 1835.268,2836.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2103.726,2946.124 1865.692,2946.889 1864.338,2835.938 2102.598,2835.221  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M3208.817,1171.932c-0.472-20.441-20.948-37.261-46.047-37.261h-948.693 c-25.436,0-50.415,17.698-50.415,38.417v1851.849c0,9.968,7.049,19.526,15.713,26.565c8.664,7.038,21.501,10.977,33.738,10.95 l991.911-2.205c12.342-0.027,24.427-4.09,33.06-11.275c8.633-7.186,13.5-17.118,13.269-27.17L3208.817,1171.932z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.53
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2510.155,1352.888 2239.893,1352.593 2237.748,1239.754 2508.273,1239.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2813.087,1352.832 2543.097,1352.536 2541.247,1239.754 2811.5,1239.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3115.717,1352.775 2845.996,1352.479 2844.441,1239.754 3114.422,1239.754  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2513.532,1555.43 2243.742,1555.57 2241.604,1443.468 2511.657,1443.378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2815.937,1555.272 2546.417,1555.412 2544.573,1443.367 2814.354,1443.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3118.039,1555.115 2848.79,1555.255 2847.24,1443.265 3116.75,1443.174  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2516.897,1756.579 2247.576,1756.81 2245.447,1645.096 2515.03,1644.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2818.778,1756.321 2549.726,1756.551 2547.889,1644.894 2817.201,1644.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3120.355,1756.063 2851.572,1756.293 2850.028,1644.692 3119.069,1644.511  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2520.254,1957.033 2251.397,1957.352 2249.276,1846.025 2518.39,1845.755  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2821.608,1956.675 2553.023,1956.993 2551.192,1845.722 2820.037,1845.453  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3122.662,1956.317 2854.346,1956.636 2852.805,1845.42 3121.381,1845.151  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2523.596,2156.793 2255.207,2157.201 2253.093,2046.259 2521.739,2045.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2824.428,2156.336 2556.309,2156.743 2554.485,2045.857 2822.862,2045.498  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3124.961,2155.879 2857.109,2156.286 2855.575,2045.455 3123.685,2045.097  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2526.926,2355.865 2259.003,2356.36 2256.896,2245.802 2525.076,2245.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2827.24,2355.309 2559.583,2355.804 2557.765,2245.3 2825.678,2244.853  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3127.252,2354.754 2859.863,2355.249 2858.335,2244.799 3125.981,2244.353  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2530.245,2554.25 2262.785,2554.833 2260.685,2444.655 2528.402,2444.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2830.04,2553.596 2562.846,2554.179 2561.035,2444.055 2828.485,2443.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3129.536,2552.944 2862.608,2553.526 2861.084,2443.456 3128.269,2442.923  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2533.553,2751.954 2266.555,2752.624 2264.462,2642.824 2531.716,2642.202  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2832.831,2751.204 2566.098,2751.872 2564.292,2642.126 2831.282,2641.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3131.812,2750.454 2865.344,2751.122 2863.826,2641.43 3130.548,2640.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2536.85,2948.979 2270.312,2949.736 2268.226,2840.313 2535.02,2839.605  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2835.613,2948.132 2569.338,2948.887 2567.538,2839.519 2834.069,2838.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3134.08,2947.287 2868.07,2948.041 2866.555,2838.724 3132.821,2838.018  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1281.937,1289.633c-0.239-12.251-10.668-22.11-23.45-22.11H483.192 c-12.954,0-26.713,10.162-26.713,22.581v1734.608c0,9.269,5.478,18.158,12.323,24.704c6.847,6.545,16.943,10.209,26.612,10.184 l783.787-2.051c9.753-0.025,19.29-3.803,26.112-10.486c6.822-6.682,10.663-15.734,10.48-25.082L1281.937,1289.633z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.51
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "836.696,1390.452 583.079,1389.61 583.174,1359.19 836.506,1359.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "837.391,1502.501 582.731,1501.388 582.827,1470.717 837.2,1471.756  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "838.092,1615.477 582.381,1614.087 582.477,1583.162 837.9,1584.477  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "838.799,1729.393 582.028,1727.721 582.125,1696.54 838.605,1698.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "839.512,1844.256 581.671,1842.297 581.769,1810.857 839.316,1812.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "840.955,2076.877 580.95,2074.332 581.049,2042.362 840.756,2044.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "843.167,2433.235 579.845,2429.772 579.947,2396.984 842.962,2400.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "840.23,1960.08 581.313,1957.83 581.411,1926.127 840.034,1928.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "841.686,2194.662 580.584,2191.816 580.685,2159.577 841.486,2162.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "842.423,2313.443 580.217,2310.291 580.318,2277.779 842.221,2280.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "843.916,2554.05 579.47,2550.272 579.573,2517.203 843.71,2520.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "844.673,2675.903 579.092,2671.803 579.196,2638.452 844.465,2642.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "845.435,2798.809 578.712,2794.382 578.816,2760.743 845.226,2765.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "846.205,2922.776 578.327,2918.017 578.432,2884.087 845.993,2888.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1169.206,1391.555 913.998,1390.708 913.723,1360.192 1168.643,1360.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1171.277,1503.962 915.013,1502.841 914.735,1472.072 1170.709,1473.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1173.364,1617.301 916.035,1615.902 915.755,1584.878 1172.791,1586.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1175.469,1731.586 917.066,1729.903 916.783,1698.621 1174.891,1700.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1177.591,1846.824 918.106,1844.853 917.821,1813.31 1177.008,1815.202  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1181.889,2080.215 920.212,2077.653 919.922,2045.578 1181.297,2048.058  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1188.474,2437.776 923.437,2434.29 923.139,2401.391 1187.866,2404.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1179.731,1963.03 919.154,1960.766 918.867,1928.958 1179.144,1931.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1184.066,2198.395 921.278,2195.53 920.985,2163.183 1183.469,2165.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1186.261,2317.576 922.353,2314.403 922.058,2281.782 1185.658,2284.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1190.707,2559.006 924.531,2555.202 924.231,2522.021 1190.094,2525.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1192.959,2681.28 925.634,2677.153 925.331,2643.686 1192.341,2647.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1195.23,2804.614 926.745,2800.158 926.441,2766.402 1194.606,2770.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1197.521,2929.017 927.869,2924.227 927.56,2890.178 1196.892,2894.876  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -787.9345 1939.1367)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 1946.778,
    cy: 1920.689,
    rx: 1222.453,
    ry: 1222.453
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179609996008858750390000000120943992015426707_",
    gradientUnits: "userSpaceOnUse",
    x1: 1318.8912,
    y1: 2829.6287,
    x2: 2732.8755,
    y2: 782.7175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000179609996008858750390000000120943992015426707_)"
    },
    cx: 1946.777,
    cy: 1920.689,
    r: 1181.804
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -813.6833 1928.4712)",
    style: {
      opacity: 0.93,
      fill: "#FFFFFF"
    },
    cx: 1921.029,
    cy: 1946.438,
    rx: 1000.253,
    ry: 1000.252
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M2921.289,1442.247c1.89,0,3.812-0.426,5.616-1.342 c6.158-3.11,8.626-10.621,5.516-16.767c-188.948-374.335-566.623-606.878-985.646-606.878 c-66.823,0-133.794,6.023-199.046,17.925c-6.784,1.23-11.282,7.73-10.047,14.52c1.233,6.792,7.713,11.328,14.524,10.035 c63.779-11.62,129.237-17.506,194.569-17.506c409.542,0,778.678,227.289,963.36,593.149 C2912.329,1439.734,2916.724,1442.247,2921.289,1442.247z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093893897602637652960000000752461209258890656_",
    gradientUnits: "userSpaceOnUse",
    x1: 1313.9993,
    y1: 2826.2493,
    x2: 2727.9824,
    y2: 779.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093893897602637652960000000752461209258890656_)"
    },
    points: "1349.014,2836.146  1210.869,2724.781 2532.492,1045.311 2654.063,1137.109  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1210.286,2206.786c0,0,130.952,159.486,179.126,121.055 c48.175-38.43-81.887-247.918-81.887-247.918L1210.286,2206.786z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183944946649484136020000003802529474922092456_",
    gradientUnits: "userSpaceOnUse",
    x1: 1110.6447,
    y1: 3204.9436,
    x2: 1215.6477,
    y2: 3204.9436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1215.646,3242.331 c0.012-0.782-0.04-1.573-0.241-2.371c-11.826-46.887-70.524-76.091-70.524-76.091l-23.26,1.823 c-13.373,41.326-11.655,66.67-9.507,77.96c0.059,0.316,0.156,0.617,0.24,0.923 C1131.54,3246.29,1171.033,3247.409,1215.646,3242.331z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021121398641567159740000010626222865933649077_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.8447,
    y1: 3085.4021,
    x2: 1119.7872,
    y2: 3260.4502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021121398641567159740000010626222865933649077_)"
    },
    d: "M1112.268,3131.048l9.851,47.424 c0.722,3.475,3.392,6.077,6.626,6.381c3.959,0.371,9.595,0.59,15.262-0.243c5.082-0.747,8.622-5.911,7.72-11.454l-6.848-42.108 H1112.268z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139992190347148670740000005221321507495338687_",
    gradientUnits: "userSpaceOnUse",
    x1: 1270.536,
    y1: 3207.7366,
    x2: 1421.6866,
    y2: 3207.7366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1421.687,3240.264 c-0.17-0.359-0.316-0.725-0.559-1.064c-12.456-17.405-44.182-52.063-106.873-67.095l-30.075-0.949 c0,0-13.391,23.276-13.645,66.391c6.869,2.808,20.156,5.833,45.845,6.552C1356.091,3245.21,1403.193,3241.792,1421.687,3240.264z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097475287573512403530000003034778416145029261_",
    gradientUnits: "userSpaceOnUse",
    x1: 1303.2271,
    y1: 3104.123,
    x2: 1283.1697,
    y2: 3279.1707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097475287573512403530000003034778416145029261_)"
    },
    d: "M1278.604,3125.578 c0.334,2.241,4.456,36.313,6.052,49.523c0.379,3.139,2.653,5.569,5.52,5.911c5.121,0.611,13.408,1.168,20.658-0.318 c3.911-0.802,6.742-4.559,6.742-8.928v-53.482L1278.604,3125.578z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033362734552164525000000012077321990446244743_",
    gradientUnits: "userSpaceOnUse",
    x1: 1541.5436,
    y1: 2303.6643,
    x2: 900.0345,
    y2: 3299.1106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#637381"
    },
    d: "M1254.476,2503.795 c0,0,72.538,275.669,71.226,622.571c-0.024,6.324-4.465,11.783-10.654,13.086c-9.12,1.921-22.527,4.202-33.625,3.891 c-5.925-0.166-10.878-4.56-11.874-10.403c-10.171-59.645-68.539-395.661-101.796-450.211c0,0-21.88,299.27-14.886,454.533 c0.174,3.86-2.653,7.209-6.492,7.653c-5.824,0.673-15.139,1.184-26.996-0.075c-4.501-0.478-8.132-3.88-8.775-8.36 c-7.245-50.48-48.943-350.955-47.17-567.406c0.1-12.206,32.28-65.279,32.28-65.279H1254.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C3C4"
    },
    d: "M1304.437,2081.275c-99.827-14.437-209.484-1.19-262.706,5.514 c-17.232,2.171-32.993,10.667-44.35,23.809c-45.034,52.116-143.856,194.802-27.54,338.58 c14.885-8.263,36.037-21.512,50.403-36.846c-12.869-36.276-13.923-82.633,13.046-139.48c0.922,4.505,2.061,8.967,3.446,13.356 c37.171,117.761,39.154,215.756,39.071,238.342c-0.012,3.068,1.83,5.829,4.677,6.969c48.921,19.604,143.093,7.937,174.705,3.226 c5.796-0.864,9.696-6.26,8.894-12.066c-11.12-80.563,26.635-198.374,56.66-275.703 C1332.609,2216.416,1310.65,2089.842,1304.437,2081.275z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049941536059464518740000011833554671528555924_",
    gradientUnits: "userSpaceOnUse",
    x1: 1215.1313,
    y1: 1848.9365,
    x2: 1159.0206,
    y2: 2160.9114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049941536059464518740000011833554671528555924_)"
    },
    d: "M1145.325,1964.175l-13.782,113.931 c-0.625,5.169,2.554,10.055,7.552,11.517c14.96,4.374,46.984,10.999,76.248-1.045c5.553-2.286,8.622-8.293,7.346-14.162 l-17.425-80.189L1145.325,1964.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1028.358,2264.044c-19.717-53.961-12.565-119.12-12.489-119.772l5.433,0.621 c-0.072,0.64-7.073,64.549,12.196,117.273L1028.358,2264.044z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124855070712464292310000018152172920716753034_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.7698,
    y1: 2570.9534,
    x2: 1127.9789,
    y2: 2666.6831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1165.087,2675.702 c-1.215,0-2.326-0.816-2.644-2.049c-6.015-23.2-51.059-48.696-51.513-48.951c-1.317-0.739-1.787-2.406-1.047-3.724 c0.74-1.317,2.398-1.788,3.723-1.047c1.937,1.086,47.533,26.897,54.131,52.349c0.379,1.463-0.5,2.956-1.961,3.333 C1165.546,2675.674,1165.314,2675.702,1165.087,2675.702z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037658667668832306340000001267523251285637535_",
    gradientUnits: "userSpaceOnUse",
    x1: 969.8429,
    y1: 2485.2412,
    x2: 1141.1193,
    y2: 2485.2412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037658667668832306340000001267523251285637535_)"
    },
    d: "M1020.245,2412.332 c-14.366,15.333-35.518,28.583-50.402,36.846c22.228,27.476,52.306,54.991,92.124,81.923l4.816,10.807 c4.127,9.261,13.145,15.402,23.272,15.885c55.651,2.652,71.05-9.152,19.821-44.881 C1109.876,2512.912,1044.359,2480.308,1020.245,2412.332z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124849616124018367810000011118086271039073692_",
    gradientUnits: "userSpaceOnUse",
    x1: 1180.4468,
    y1: 5324.0889,
    x2: 1289.1831,
    y2: 5324.0889,
    gradientTransform: "matrix(0.5644 0.8255 -0.8255 0.5644 5099.5723 -1768.4667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124849616124018367810000011118086271039073692_)"
    },
    d: "M1429.394,2170.834 c0,0-70.221,72.998-86.445,99.48c-16.224,26.482,1.835,74.71,38.69,63.514c36.855-11.196,79.758-137.858,79.758-137.858 L1429.394,2170.834z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039124734149445499840000013661490166403214003_",
    gradientUnits: "userSpaceOnUse",
    x1: 1299.114,
    y1: 2290.521,
    x2: 1433.9546,
    y2: 2109.6377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1311.854,2067.157 c0,0,61.709,162.746,81.205,196.602c22.631,39.3,88.725,14.257,85.436-18.633c-3.289-32.89-80.51-168.834-80.51-168.834 L1311.854,2067.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091711813803764981300000012192106287891616442_",
    gradientUnits: "userSpaceOnUse",
    x1: 1755.799,
    y1: 1766.8661,
    x2: 1271.1689,
    y2: 2604.3818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B6C3C4"
    },
    points: "1395.234,1948.605  1778.777,1815.625 1774.749,2175.49 1384.753,2088.472  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EEF8F2"
    },
    cx: 1779.138,
    cy: 1996.602,
    rx: 37.682,
    ry: 184.938
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142882100277940797360000013410561619715845820_",
    gradientUnits: "userSpaceOnUse",
    x1: 2067.2324,
    y1: 1747.5277,
    x2: 1989.7999,
    y2: 1814.8604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C3C4"
    },
    d: "M1781.998,2168.892 c-3.406-3.464-10.825-16.826-17.186-51.379c-6.148-33.392-9.533-76.703-9.533-121.955s3.385-88.564,9.533-121.955 c6.361-34.553,13.78-47.915,17.186-51.379c3.406,3.464,10.825,16.826,17.186,51.379c6.148,33.392,9.533,76.703,9.533,121.955 s-3.385,88.563-9.533,121.955C1792.823,2152.066,1785.404,2165.428,1781.998,2168.892z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078723702167672439040000010954029128255574453_",
    d: "M1781.998,2168.892 c-3.406-3.464-10.825-16.826-17.186-51.379c-6.148-33.392-9.533-76.703-9.533-121.955s3.385-88.564,9.533-121.955 c6.361-34.553,13.78-47.915,17.186-51.379c3.406,3.464,10.825,16.826,17.186,51.379 c6.148,33.392,54.657,76.703,54.657,121.955s-48.51,88.563-54.657,121.955 C1792.823,2152.066,1785.404,2165.428,1781.998,2168.892z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155121114227439539120000013940807573613955770_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078723702167672439040000010954029128255574453_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011006172431151183410000009857874019780708013_",
    gradientUnits: "userSpaceOnUse",
    x1: 1862.6213,
    y1: 1989.4309,
    x2: 1595.1184,
    y2: 2004.7795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000155121114227439539120000013940807573613955770_)",
      fill: "#00AB65"
    },
    d: " M1830.296,1994.18c0,31.423-16.927,56.896-50.431,56.896c-33.503,0-60.663-25.473-60.663-56.896s27.16-56.896,60.663-56.896 C1813.368,1937.284,1830.296,1962.758,1830.296,1994.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134962094984415055760000005647752236162035079_",
    gradientUnits: "userSpaceOnUse",
    x1: 1355.8977,
    y1: 2084.4719,
    x2: 1346.0311,
    y2: 1836.1674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1333.375,1940.869 c18.042-2.095,43.915-2.849,71.889,3.557c-9.216,48.144-7.825,98.324,2.834,150.284l-78.901,0 c-12.579,0-23.306-9.137-25.268-21.563c-3.932-24.907-8.74-66.768-3.614-100.39 C1302.887,1955.885,1316.421,1942.838,1333.375,1940.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1380.727,1978.657h-61.472c-2.391,0-4.588-1.305-5.73-3.406c-1.143-2.1-1.045-4.653,0.255-6.66 c0.746-1.157,2.296-1.486,3.453-0.738c1.158,0.748,1.488,2.294,0.738,3.453c-0.444,0.688-0.189,1.32-0.058,1.559 c0.13,0.241,0.522,0.798,1.343,0.798h61.472c0.844,0,1.53-0.686,1.53-1.528v-4.373c0-0.844-0.686-1.53-1.53-1.53h-61.929 c-1.379,0-2.497-1.119-2.497-2.497c0-1.379,1.119-2.497,2.497-2.497h61.929c3.598,0,6.524,2.926,6.524,6.524v4.373 C1387.251,1975.731,1384.324,1978.657,1380.727,1978.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1375.245,2005.883h-61.472c-2.391,0-4.588-1.304-5.729-3.404 c-1.143-2.101-1.047-4.653,0.252-6.661c0.75-1.161,2.295-1.491,3.453-0.741c1.159,0.75,1.489,2.295,0.741,3.453 c-0.445,0.689-0.19,1.322-0.06,1.562c0.13,0.239,0.522,0.797,1.343,0.797h61.472c0.844,0,1.53-0.686,1.53-1.528v-4.373 c0-0.844-0.686-1.53-1.53-1.53h-61.929c-1.379,0-2.497-1.118-2.497-2.497c0-1.379,1.118-2.497,2.497-2.497h61.929 c3.598,0,6.524,2.926,6.524,6.524v4.373C1381.769,2002.957,1378.843,2005.883,1375.245,2005.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1450.966,1939.781c-1.058,0-2.042-0.678-2.38-1.739c-0.418-1.315,0.309-2.718,1.622-3.138 l290.49-92.439c1.315-0.419,2.72,0.311,3.138,1.622c0.418,1.315-0.309,2.718-1.622,3.137l-290.49,92.44 C1451.472,1939.744,1451.216,1939.781,1450.966,1939.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1411.685,1955.839c-0.985,0-1.918-0.585-2.313-1.552c-0.522-1.276,0.091-2.734,1.367-3.256 l14.95-6.111c1.276-0.524,2.736,0.091,3.256,1.367c0.522,1.276-0.091,2.734-1.367,3.256l-14.95,6.111 C1412.319,1955.781,1411.998,1955.839,1411.685,1955.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1380.727,2037.769h-61.472c-2.391,0-4.586-1.306-5.729-3.404 c-1.143-2.102-1.047-4.654,0.252-6.662c0.749-1.161,2.297-1.489,3.453-0.741c1.159,0.749,1.489,2.295,0.741,3.453 c-0.447,0.689-0.19,1.323-0.06,1.562c0.13,0.241,0.523,0.798,1.343,0.798h61.472c0.844,0,1.53-0.686,1.53-1.53v-4.373 c0-0.842-0.686-1.528-1.53-1.528h-61.929c-1.379,0-2.497-1.119-2.497-2.497c0-1.379,1.119-2.497,2.497-2.497h61.929 c3.598,0,6.524,2.926,6.524,6.522v4.373C1387.251,2034.843,1384.324,2037.769,1380.727,2037.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1386.483,2073.16h-61.473c-2.391,0-4.586-1.305-5.729-3.406c-1.143-2.1-1.047-4.653,0.252-6.66 c0.75-1.161,2.296-1.491,3.453-0.741c1.159,0.75,1.489,2.295,0.741,3.453c-0.445,0.689-0.19,1.322-0.06,1.562 c0.132,0.241,0.524,0.798,1.343,0.798h61.473c0.842,0,1.528-0.686,1.528-1.528v-4.375c0-0.842-0.686-1.528-1.528-1.528h-61.93 c-1.379,0-2.497-1.119-2.497-2.497c0-1.378,1.119-2.497,2.497-2.497h61.93c3.596,0,6.522,2.926,6.522,6.522v4.375 C1393.005,2070.234,1390.079,2073.16,1386.483,2073.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1441.391,2265.583c-2.899,0-5.828-0.314-8.751-0.949c-12.784-2.786-23.194-11.216-28.557-23.129 l-49.114-109.113c-0.566-1.257-0.005-2.734,1.253-3.302c1.255-0.564,2.736-0.005,3.302,1.253l49.114,109.111 c4.706,10.455,13.843,17.853,25.065,20.298c11.022,2.398,22.179-0.45,30.607-7.823c0.46-0.402,0.919-0.814,1.38-1.236 c1.016-0.933,2.594-0.862,3.528,0.156c0.931,1.018,0.862,2.598-0.156,3.528c-0.491,0.45-0.979,0.886-1.466,1.312 C1460.203,2262.159,1450.974,2265.583,1441.391,2265.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1349.987,2117.731c-0.953,0-1.863-0.548-2.279-1.473l-5.479-12.173 c-0.566-1.257-0.005-2.736,1.253-3.302c1.253-0.566,2.738-0.005,3.302,1.253l5.478,12.173c0.566,1.257,0.005,2.736-1.253,3.302 C1350.678,2117.662,1350.33,2117.731,1349.987,2117.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M1821.313,1993.458c-1.297,0-2.394-1.005-2.487-2.32c-1.071-15.109-6.28-26.359-15.478-33.435 c-15.943-12.261-38.885-8.065-39.117-8.018c-1.356,0.255-2.663-0.629-2.922-1.983c-0.258-1.353,0.626-2.661,1.979-2.921 c1.027-0.197,25.325-4.685,43.074,8.941c10.398,7.982,16.267,20.453,17.445,37.063c0.097,1.375-0.938,2.57-2.313,2.668 C1821.433,1993.456,1821.373,1993.458,1821.313,1993.458z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085227032679935359100000001584099660642238885_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.1353,
    y1: 2149.1614,
    x2: 1455.1161,
    y2: 2149.1614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085227032679935359100000001584099660642238885_)"
    },
    d: "M1402.806,2128.87 c0,0,20.006-16.983,35.641,0c15.635,16.983,18.727,46.62,15.546,48.068C1450.812,2178.386,1354.138,2154.381,1402.806,2128.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007391023697341657330000015872457392901277887_",
    gradientUnits: "userSpaceOnUse",
    x1: 862.8607,
    y1: 2176.2375,
    x2: 865.105,
    y2: 1956.2811,
    gradientTransform: "matrix(0.9963 -0.0858 0.0858 0.9963 145.6489 -48.9289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007391023697341657330000015872457392901277887_)"
    },
    d: "M1213.256,1881.799 c0,0,28.41,52.437,32.466,80.895c4.056,28.458,11.816,46.482-20.751,55.089c-32.567,8.607-61.839-5.465-79.383-32.649 c0,0-27.424-41.854-23.669-60.285C1125.675,1906.417,1213.256,1881.799,1213.256,1881.799z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017480421646982559370000001978382045388876426_",
    gradientUnits: "userSpaceOnUse",
    x1: 807.2175,
    y1: 1980.9255,
    x2: 933.9592,
    y2: 2144.1052,
    gradientTransform: "matrix(0.9963 -0.0858 0.0858 0.9963 145.6489 -48.9289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M1155.123,1963.681l1.811-0.992 c2.305-1.263,3.084-4.203,1.68-6.425c-5.438-8.607-16.306-28.467-4.979-34.294c14.598-7.51,73.486-24.897,84.586-47.281 c10.669-21.512-2.618-46.95-19.815-53.029c-1.151-0.407-2.422,0.104-2.898,1.229l-1.154,2.729 c-0.79,1.868-3.452,1.824-4.181-0.068c-0.7-1.817-3.209-1.965-4.096-0.231c-3.427,6.706-13.271,17.946-41.516,25.716 c-40.141,11.042-65.686,29.872-63.929,58.116c0.112,1.795-1.708,2.954-3.317,2.154c-3.17-1.576-8.064-2.022-14.038,3.949 c-10.39,10.384-3.702,34.423,22.587,52.406c1.249,0.854,1.396,2.677,0.204,3.608c-4.202,3.281-10.245,10.749,7.743,18.46 c18.606,7.976,31.821,6.051,36.862,4.767c1.254-0.32,1.968-1.622,1.582-2.857l-7.593-24.303 c-0.43-1.375,0.523-2.796,1.959-2.919L1155.123,1963.681z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121983816347990203910000006850805775253051552_",
    gradientUnits: "userSpaceOnUse",
    x1: 818.272,
    y1: 2175.7834,
    x2: 820.5163,
    y2: 1955.8301,
    gradientTransform: "matrix(0.9963 -0.0858 0.0858 0.9963 145.6489 -48.9289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121983816347990203910000006850805775253051552_)"
    },
    d: "M1156.6,1968.82 c0,0-12.046-34.022-26.808-22.92c-14.762,11.102,11.456,38.296,24.112,38.518L1156.6,1968.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088126570254437920180000016395033969248232360_",
    gradientUnits: "userSpaceOnUse",
    x1: 4038.8206,
    y1: 3204.1497,
    x2: 4125.7109,
    y2: 3204.1497,
    gradientTransform: "matrix(1 0 0 1 -1193.7806 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M2931.929,3233.266 c0.01-0.655-0.033-1.318-0.201-1.985c-9.894-39.225-50.349-59.331-50.349-59.331l-19.46,1.526 c-11.188,34.572-18.402,51.45-16.605,60.895c0.05,0.265,0.131,0.517,0.201,0.773 C2861.566,3236.577,2894.606,3237.513,2931.929,3233.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158715004943711692000000003634712327371380363_",
    gradientUnits: "userSpaceOnUse",
    x1: 4257.7808,
    y1: 3098.3555,
    x2: 3938.1987,
    y2: 3349.2922,
    gradientTransform: "matrix(1 0 0 1 -1193.7806 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M2845.514,3235.143 c0.867,3.154,3.195,5.609,6.175,6.236c22.834,4.802,59.127,0.938,74.365-1.054c3.361-0.439,5.819-3.548,5.874-7.058 C2894.606,3237.513,2861.566,3236.577,2845.514,3235.143z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032616340028545152690000009243516155245130157_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.1644,
    y1: 3102.1912,
    x2: 588.8176,
    y2: 3253.582,
    gradientTransform: "matrix(-1 0 0 1 3479.7163 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032616340028545152690000009243516155245130157_)"
    },
    d: "M2897.401,3141.668l-8.52,41.014 c-0.624,3.006-2.933,5.257-5.731,5.519c-3.424,0.321-8.297,0.51-13.199-0.211c-4.396-0.645-7.456-5.111-6.677-9.906 l5.923-36.417H2897.401z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019669576476691692880000006379656680741826730_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.6636,
    y1: 3172.8281,
    x2: 591.6174,
    y2: 3415.4919,
    gradientTransform: "matrix(-1 0 0 1 3479.7163 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M2680.174,3234.802 c20.783-0.581,31.532-3.029,37.09-5.3c0.013,2.067,0.001,4.17-0.066,6.348c-0.072,2.328-1.795,4.187-3.916,4.172l-114.109-0.736 c-3.642-0.024-5.77-4.247-4.191-7.587C2609.942,3232.936,2648.048,3235.701,2680.174,3234.802z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099663550435201548080000004967922649570967211_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.4528,
    y1: 3205.3845,
    x2: 884.7355,
    y2: 3205.3845,
    gradientTransform: "matrix(-1 0 0 1 3479.7163 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M2594.981,3231.7 c0.137-0.29,0.256-0.587,0.452-0.86c10.077-14.081,35.744-42.12,86.462-54.281l24.33-0.768c0,0,10.834,18.831,11.039,53.711 c-5.557,2.271-16.307,4.719-37.09,5.3C2648.048,3235.701,2609.942,3232.936,2594.981,3231.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035522153584711940930000007543025130138994362_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9,
    y1: 3121.5596,
    x2: 772.6733,
    y2: 3263.1758,
    gradientTransform: "matrix(-1 0 0 1 3479.7163 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035522153584711940930000007543025130138994362_)"
    },
    d: "M2710.737,3138.917 c-0.271,1.813-3.605,29.377-4.896,40.065c-0.307,2.54-2.146,4.505-4.466,4.782c-4.144,0.495-10.848,0.945-16.713-0.257 c-3.164-0.648-5.454-3.688-5.454-7.223v-43.268L2710.737,3138.917z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121277289166787684940000017344062879444349592_",
    gradientUnits: "userSpaceOnUse",
    x1: -1123.1085,
    y1: 3117.0315,
    x2: -1103.6423,
    y2: 2507.1003,
    gradientTransform: "matrix(-1 0 0 1 1667.881 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#637381"
    },
    d: "M2881.143,2603.084 c0,0,38.934,346.078,17.304,562.376c0,0-25.956,0-38.934-4.326c0,0-40.458-338.375-53.546-435.203 c-0.493-3.65-5.704-3.816-6.42-0.204c-16.148,81.461-79.575,400.912-87.117,431.081c0,0-21.63,8.652-38.934,0 c0,0,34.608-462.879,60.564-545.073L2881.143,2603.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C3C4"
    },
    d: "M2959.011,2200.768c0,0-164.387-25.956-294.166,8.652l8.652,134.105 c0,0,34.608,186.017,60.564,268.21c0,0,99.497,17.304,147.083-8.652c0,0,38.934-233.603,60.564-268.211 C2941.707,2334.873,2963.337,2244.028,2959.011,2200.768z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152958511459645784550000012168909802551081373_",
    gradientUnits: "userSpaceOnUse",
    x1: -1193.3083,
    y1: 2142.4746,
    x2: -1115.5197,
    y2: 2142.4746,
    gradientTransform: "matrix(-1 0 0 1 1667.881 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152958511459645784550000012168909802551081373_)"
    },
    d: "M2844.813,2082.562l16.376,110.745 c0,0-45.752,21.017-77.789-0.901l6.897-78.157L2844.813,2082.562z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027582645592353436370000017166526325500280192_",
    gradientUnits: "userSpaceOnUse",
    x1: 6944.7856,
    y1: -1833.6688,
    x2: 7081.0571,
    y2: -1866.8353,
    gradientTransform: "matrix(-0.8757 -0.4828 -0.4828 0.8757 1534.2062 1095.1436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027582645592353436370000017166526325500280192_)"
    },
    d: "M2774.305,2010.45 c-0.516,0.935-10.386,56.779-16.462,91.348c-2.511,14.282,7.988,27.55,22.465,28.407l13.256,0.784 c24.356,1.443,45.805-15.898,49.497-40.017l9.585-62.618C2852.645,2028.353,2786.826,1987.738,2774.305,2010.45z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093169279295184584780000003509251741730222212_",
    gradientUnits: "userSpaceOnUse",
    x1: -1640.7444,
    y1: 192.2534,
    x2: -1500.3839,
    y2: 192.2534,
    gradientTransform: "matrix(-0.8757 -0.4828 -0.4828 0.8757 1534.2062 1095.1436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M2866.937,2028.508 c5.083-6.32,9.514-16.54-1.309-27.286c-10.957-10.881-23.388-8.168-31.274-4.52c-3.489,1.615-7.791,0.9-10.275-2.036 c-1.104-1.305-2.743-2.192-5.174-1.919c-4.584,0.514-8.676-2.512-9.221-7.093c-0.932-7.853-5.116-17.1-19.001-19.782 c-25.467-4.922-38.171,20.564-37.717,38.478c0.454,17.912,28.367,21.68,44.205,18.706c11.633-2.185,21.691,8.038,26.211,13.619 c1.641,2.026,2.253,4.68,1.663,7.219l-4.027,17.305c2.789,5.38,5.526,10.873,9.443,15.463c2.82,3.306,5.913,5.13,9.191,5.902 c4.749-8.838,18.029-10.337,24.2-10.535c2.362-0.075,4.567-1.116,6.118-2.897c4.656-5.34,11.944-17.253-2.005-28.952 C2864.497,2037.27,2864.101,2032.036,2866.937,2028.508z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000214002736485248140000000644610275563706556_",
    gradientUnits: "userSpaceOnUse",
    x1: 6939.9868,
    y1: -1853.4094,
    x2: 7076.2593,
    y2: -1886.5762,
    gradientTransform: "matrix(-0.8757 -0.4828 -0.4828 0.8757 1534.2062 1095.1436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000214002736485248140000000644610275563706556_)"
    },
    d: "M2835.061,2101.089 c0,0,0.549-31.247,13.195-34.182c12.647-2.935,26.291,6.209,15.475,24.916 C2850.277,2115.093,2835.061,2101.089,2835.061,2101.089z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C3C4"
    },
    d: "M2885.017,2350.142c0,0,371.444-101.107,187.007-361.126l-12.479,17.668 c0,0,55.569,176.114-128.51,192.849C2931.036,2199.533,2883.361,2322.492,2885.017,2350.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C3C4"
    },
    d: "M2751.018,2362.693c0,0-371.444-101.107-187.008-361.126l12.479,17.667 c0,0-55.568,176.115,128.51,192.849C2704.999,2212.084,2752.675,2335.043,2751.018,2362.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105385267414492739450000017413350176070235568_",
    gradientUnits: "userSpaceOnUse",
    x1: 2361.5068,
    y1: 1733.7198,
    x2: 3237.8286,
    y2: 1733.7198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M3237.371,1632.286l-32.444,350.59 c-2.516,27.185-14.557,44.458-26.676,38.206c-46.399-23.935-599.339-148.052-739.727,13.78 c-12.038,13.876-40.168-30.63-43.349-60.021l-33.056-335.254c-2.352-21.728,2.237-43.8,10.9-55.022 c178.587-231.369,732.529-178.047,854.49-4.106C3235.285,1591.55,3239.238,1612.115,3237.371,1632.286z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178904251104900281480000002199456719010270616_",
    gradientUnits: "userSpaceOnUse",
    x1: -2564.5579,
    y1: 1032.0931,
    x2: -2689.1233,
    y2: 1341.8232,
    gradientTransform: "matrix(-1 0 0 1 -39.6348 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178904251104900281480000002199456719010270616_)"
    },
    d: "M2598.146,1706.296 c4.545,112.556,97.797,204.402,207.175,206.512c108.111,2.085,193.418-84.428,191.645-194.543 c-1.797-111.612-92.189-206.857-203.059-211.403C2681.705,1502.262,2593.537,1592.176,2598.146,1706.296z M2916.24,1835.108 l-212.845-267.759c25.984-16.977,57.443-26.229,91.512-24.897c91.756,3.587,166.856,82.262,168.536,174.807 C2964.294,1764.197,2946.123,1805.875,2916.24,1835.108z M2633.003,1707.343c-1.84-48.082,16.289-91.052,46.932-121.123 l213.488,267.281c-25.251,16.63-55.817,25.994-89.058,25.292C2713.631,1876.877,2636.568,1800.536,2633.003,1707.343z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098928234649858210910000012529734839281385900_",
    gradientUnits: "userSpaceOnUse",
    x1: -1358.4093,
    y1: 1911.4027,
    x2: -1402.3368,
    y2: 2055.7356,
    gradientTransform: "matrix(-1 0 0 1 1667.881 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098928234649858210910000012529734839281385900_)"
    },
    d: "M3073.278,1990.353 c0,0,4.184-50.203-20.918-54.386c-25.101-4.184-33.469,20.917-37.652,33.468c-4.184,12.551,37.652,37.652,46.019,37.652 C3069.095,2007.088,3073.278,1990.353,3073.278,1990.353z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083776236304893440630000014209860833266740138_",
    gradientUnits: "userSpaceOnUse",
    x1: 2838.8936,
    y1: 1923.9534,
    x2: 2794.9661,
    y2: 2068.2866,
    gradientTransform: "matrix(1 0 0 1 -229.1484 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083776236304893440630000014209860833266740138_)"
    },
    d: "M2562.757,2002.904 c0,0-4.184-50.203,20.918-54.387c25.102-4.182,33.469,20.918,37.653,33.469c4.183,12.551-37.653,37.652-46.02,37.652 C2566.94,2019.638,2562.757,2002.904,2562.757,2002.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070806884266515895770000003096019420527296669_",
    gradientUnits: "userSpaceOnUse",
    x1: 776.9014,
    y1: 1521.9537,
    x2: 711.2548,
    y2: 2365.2537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070806884266515895770000003096019420527296669_)"
    },
    d: "M800.628,1765.741 c0,0,155.391,198.952-21.899,401.3l-66.653-6.21c0,0,128.306-206.017,71.158-370.241l-94.415,6.893l-52.211-34.032 L800.628,1765.741z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134228328234397002280000010908461808224392351_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.8566,
    y1: 1532.903,
    x2: 1238.2794,
    y2: 1532.903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M1216.576,1318.464l-645.437-38.096 c-12.657-0.747-23.322,7.988-23.694,19.406l-14.579,446.8c-0.375,11.494,9.797,21.213,22.55,21.519 c116.857,2.807,635.67,15.353,658.515,17.381c22.576,2.004,24.273-357.426,24.348-446.127 C1238.289,1328.379,1228.72,1319.181,1216.576,1318.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171701929658604244240000013444375783637484436_",
    gradientUnits: "userSpaceOnUse",
    x1: 550.8027,
    y1: 1532.6428,
    x2: 1220.3326,
    y2: 1532.6428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171701929658604244240000013444375783637484436_)"
    },
    d: "M1201.879,1769.216 c-85.346-3.263-553.433-14.56-646.403-16.794l-0.136-0.004c-2.592-0.127-4.628-2.382-4.534-5.018l14.576-446.797 c0.045-1.408,0.656-2.661,1.701-3.521c0.638-0.537,1.728-1.136,3.282-1.074l645.436,38.093c2.541,0.151,4.531,2.279,4.531,4.85 c-0.184,219.426-6.585,387.608-16.31,428.454l-0.446,1.876L1201.879,1769.216z M569.675,1300.786l-14.173,446.725l0.078,0.003 c92.404,2.217,554.978,13.383,644.719,16.728c9.394-43.556,15.555-209.496,15.799-425.03c-0.027-0.038-0.199-0.186-0.521-0.203 l-645.424-38.093c-0.027-0.003-0.057-0.003-0.084-0.003C569.814,1300.917,569.682,1300.968,569.675,1300.786z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065758531186067504930000015465753658720416176_",
    gradientUnits: "userSpaceOnUse",
    x1: -668.5704,
    y1: 880.1304,
    x2: -788.4065,
    y2: 1178.1013,
    gradientTransform: "matrix(-1 0 0 1 -39.6348 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065758531186067504930000015465753658720416176_)"
    },
    d: "M699.378,1528.737 c4.372,108.283,94.084,196.642,199.309,198.671c104.007,2.006,186.075-81.223,184.369-187.157 c-1.729-107.375-88.689-199.004-195.349-203.377C779.765,1332.449,694.945,1418.949,699.378,1528.737z M1005.396,1652.658 l-204.764-257.593c24.998-16.333,55.262-25.233,88.038-23.951c88.273,3.451,160.521,79.139,162.137,168.171 C1051.625,1584.44,1034.145,1624.535,1005.396,1652.658z M732.912,1529.743c-1.77-46.256,15.67-87.596,45.15-116.525 l205.382,257.133c-24.292,15.999-53.698,25.007-85.677,24.332C810.479,1692.842,736.342,1619.399,732.912,1529.743z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180352679749115163490000014517516970803559589_",
    gradientUnits: "userSpaceOnUse",
    x1: -1522.3374,
    y1: 2957.063,
    x2: -1286.9858,
    y2: 2957.063,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180352679749115163490000014517516970803559589_)"
    },
    d: "M715.522,2739.799 c0,0-125.899,274.4-191.954,388.056c0,0-13.119,71.515,0,94.003l11.181,4.97l-52.181-1.553c0,0-4.636-96.195-1.015-101.568 c3.62-5.373,10.86-5.021,10.86-5.021s22.375-177.264,87.172-215.095l62.797-216.292L715.522,2739.799z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060752300950913847530000014944699666320774837_",
    gradientUnits: "userSpaceOnUse",
    x1: -1198.8403,
    y1: 2430.7446,
    x2: -1315.3937,
    y2: 3188.3381,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M557.034,3240.299 c0.078,1.258-40.746,0.683-62.922,0.278c-8.188-0.15-15.169-5.905-16.914-13.906l-16.747-87.984 c-1.591-8.361,3.718-16.483,12.015-18.379l9.347-2.137c0,0,13.335,18.293,9.138,35.515s-7.933,61.835,2.675,67.034 c10.608,5.198,41.123,6.107,41.123,6.107S556.336,3228.968,557.034,3240.299z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084488068495090656480000000852974044211844785_",
    gradientUnits: "userSpaceOnUse",
    x1: -1445.4548,
    y1: 2392.8062,
    x2: -1562.0084,
    y2: 3150.4009,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M834.852,3241.896 c4.129,2.353,2.426,8.656-2.326,8.609c-37.111-0.373-120.268-1.547-127.658-4.62c-9.54-3.967,3.477-38.248,17.176-49.851 l75.641,24.687L834.852,3241.896z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055679919591838710480000001803757209296584321_",
    gradientUnits: "userSpaceOnUse",
    x1: -1665.1473,
    y1: 2974.5627,
    x2: -1528.8601,
    y2: 2974.5627,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055679919591838710480000001803757209296584321_)"
    },
    d: "M858.332,2722.298 c0,0-81.359,393.586-104.374,470.363l54.446,34.167c0,0-27.284-4.64-47.517-6.107c-20.232-1.466-38.842-24.687-38.842-24.687 l6.523-10.403c0,0,20.402-391.443,15.436-435.893L858.332,2722.298z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035525567412305382650000003962573454699839415_",
    gradientUnits: "userSpaceOnUse",
    x1: -1629.1741,
    y1: 2323.4314,
    x2: -1918.7037,
    y2: 1798.2389,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035525567412305382650000003962573454699839415_)"
    },
    d: "M1060.294,1804.256 c0,0,11.222,204.74-175.181,309.363l44.878,102.352c0,0,168.763-102.076,162.522-380.48c-0.179-7.99,2.703-15.749,7.92-21.802 l35.868-41.611c13.666-15.854,18.772-37.36,13.693-57.665l-4.721-18.872c-1.581-6.318-8.777-9.358-14.408-6.087l-3.751,2.179 c-11.941,6.935-21.399,17.449-27.038,30.054l-17.612,39.37c-6.579,14.706-21.747,23.634-37.798,22.249l-10.89-0.94 L1060.294,1804.256z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011727343692866886430000010245159847187181701_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.8098,
    y1: 2248.646,
    x2: 936.5753,
    y2: 2248.646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C3C4"
    },
    d: "M891.601,2098.276 c-31.185,8.648-136.835,36.44-202.791,35.305l40.496,228.522l-3.223,37.272l132.032-0.592c0,0,37.168-86.319,66.493-129.354 c8.47-12.43,2.166-27.254-2.634-41.509l6.595-4.391c6.711-4.468,9.622-12.862,7.117-20.525l-32.152-98.371 C901.863,2099.675,896.642,2096.878,891.601,2098.276z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005986352793897387170000008751265340199420051_",
    gradientUnits: "userSpaceOnUse",
    x1: -1785.476,
    y1: 2358.8743,
    x2: -1348.4025,
    y2: 2851.7959,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#637381"
    },
    d: "M868.694,2379.28l-2.597,22.581 c0,0,37.312,111.741-18.657,372.726c0,0-121.215,34.34-220.84-47.831c0,0,28.103-246.33,35.779-257.804 c38.234-57.151,63.703-69.575,63.703-69.575l1.149-24.669C727.231,2374.706,833.787,2393.971,868.694,2379.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144307801149706965250000007220140359141496981_",
    gradientUnits: "userSpaceOnUse",
    x1: -1623.8313,
    y1: 2083.0374,
    x2: -1540.4309,
    y2: 2083.0374,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144307801149706965250000007220140359141496981_)"
    },
    d: "M817.01,2116.694 c0.463-0.612-27.564-84.62-27.564-84.62l-40.147,3.642l-15.683,95.302C733.615,2131.019,796.534,2143.719,817.01,2116.694z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063605588133197569100000001645462918353809086_",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.5024,
    y1: 1807.7482,
    x2: 1439.6771,
    y2: 1535.0646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063605588133197569100000001645462918353809086_)"
    },
    d: "M758.91,1899.593 c2.677,1.667,85.789,36.015,67.932,122.3c-1.055,5.099-4.458,9.421-9.213,11.542c-12.196,5.44-38.453,14.755-69.858,11.563 c-43.539-4.425-72.07-80.402-70.856-102.511C678.129,1920.378,732.378,1883.072,758.91,1899.593z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093152624645112843480000008302950024505764511_",
    gradientUnits: "userSpaceOnUse",
    x1: -1391.5049,
    y1: 1938.6681,
    x2: -1605.1848,
    y2: 2366.0271,
    gradientTransform: "matrix(-1 0 0 1 -806.8155 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M733.615,1866.048 c2.185,0.286,48.029,16.254,25.295,49.474c-22.734,33.22-31.263,52.776-20.51,67.364c9.797,13.29,31.499,5.715,29.605,33.365 c-0.379,5.535,2.015,10.908,6.609,14.018c20.45,13.843,70.344,56.452,20.911,117.217c-4.018,4.939-4.846,11.757-1.746,17.318 c14.478,25.969,44.89,102.044-65.212,144.244c-108.799,41.7-148.081-29.42-159.056-57.846c-2.374-6.148-8.427-9.912-15.011-9.601 c-11.955,0.565-28.896-1.424-28.117-17.401c0.473-9.704,6.528-18.4,13.683-25.372c7.082-6.901,5.683-18.983-2.914-23.868 c-6.494-3.69-12.242-9.451-14.667-18.439c-6.593-24.433,6.57-97.487,76.594-109.868c5.841-1.033,11.958-6.509,12.808-12.38 c0.013-0.087,0.026-0.174,0.041-0.262c0.939-5.678-0.982-11.482-5.622-14.886c-11.181-8.202-25.52-24.716-13.874-51.198 c10.33-23.487,30.141-31.41,44.857-33.935c8.64-1.482,14.321-9.654,12.499-18.229 C644.824,1892.396,649.15,1854.973,733.615,1866.048z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDisable);
export default __webpack_public_path__ + "static/media/user-disable.0b3969edb9a8710d404206c4a4492e6d.svg";
export { ForwardRef as ReactComponent };